/*
 * FileName : index.tsx
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-07-27 09:39:28
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

import { get, post } from 'src/api/http';
import { ReturnData } from '../types';
import types from './type';

class HomePage {
    getDcuCount () {
        return get('/business/common/mdr-home-page/dcu-count');
    }
    getMeterCount () {
        return get('/business/common/mdr-home-page/meter-count');
    }
    getDcuRelationMeters () {
        return get('/business/common/mdr-home-page/dcu-relation-meters');
    }
    getMeterTypeRelationMeters () {
        return get('/business/common/mdr-home-page/meter-type-relation-meters');
    }
    getDailyFrozenSuccessRate (): Promise<ReturnData<types.FrozenRate[]>> {
        return get('/business/common/mdr-home-page/daily-frozen-success-rate');
    }
    getMonthlyFrozenSuccessRate (): Promise<ReturnData<types.FrozenRate[]>> {
        return get('/business/common/mdr-home-page/monthly-frozen-success-rate');
    }
    getCurveFrozenSuccessRate (): Promise<ReturnData<types.FrozenRate[]>> {
        return get('/business/common/mdr-home-page/curve-frozen-success-rate');
    }
    getCustomers () {
        return get('/business/common/mdr-home-page/customers-count');
    }
    getQuickMenus () {
        return get('/business/common/common-box/func-list');
    }
    // 获取菜单数据
    getMenuData (subno:string = '10'): Promise<types.MenuTree[]> {
        return get(`/business/common/mdr-home-page/menu-tree-syn?id=&rootIcon=&netIcon=&dstIcon=&roomIcon=&subno=${subno}`);
    }
    getNewMenuData (): Promise<types.MenuTree[]> {
        return get('/business/common/mdr-home-page/current-menu-tree');
    }
    getPVMSMenuData (subno:string = '10'): Promise<types.MenuTree[]> {
        return get(`/business/common/prepaid-home-page/menu-tree-syn?id=&rootIcon=&netIcon=&dstIcon=&roomIcon=&subno=${subno}`);
    }
    getRechargeOverView (): Promise<types.RechargeOveriewData> {
        return get('/business/common/prepaid-home-page/getRechargeOverView');
    }
    getMeterTypeDetail (): Promise<types.MeterTypeRows[]> {
        return get('/business/common/prepaid-home-page/getMeterTypeDetail');
    }
    getRechargeAmount (data: types.RechargeAmountParams): Promise<types.RechargeAmountList> {
        return get('/business/common/prepaid-home-page/getRechargeAmount', data);
    }
    getVendingTimes (data: types.RechargeAmountParams): Promise<any> {
        return get('/business/common/prepaid-home-page/getVendingTimes', data);
    }
    getEventOverView (): Promise<types.ObjectAttr> {
        return get('/business/common/prepaid-home-page/getEventOverView');
    }
    getMeterOverView (): Promise<types.ObjectAttr> {
        return get('/business/common/prepaid-home-page/getMeterOverView');
    }
    getSuccessRatio (data:types.GetRatioParam): Promise<types.RatioRows[]> {
        return get('/business/common/mdr-home-page/getMeterSuccessStatistics', data);
    }
    getMeterCompleteRatio (data: types.GetRatioParam): Promise<types.RatioRows[]> {
        return get('/business/common/mdr-home-page/getMeterCompleteStatistics', data);
    }
    getMeterOnlinePushRatio (data: types.GetRatioParam): Promise<types.RatioRows[]> {
        return get('/business/common/mdr-home-page/getMeterOnlinePushDataStatistics', data);
    }
    getMeterConnectRatio (data: types.GetRatioParam): Promise<types.RatioRows[]> {
        return get('/business/common/mdr-home-page/getMeterConnectStatistics', data);
    }
    getDcuStatistics (cstType:string): Promise<types.DCUStatistic> {
        return get('/business/common/mdr-home-page/getDcuStatistics', {cstType});
    }
    getMeterStatistics (meterType:string): Promise<types.MeterStatistic> {
        return get('/business/common/mdr-home-page/getMeterStatistics', {meterType});
    }
    getConsumptionStatistics (data:types.QueryConsumptionStatisticsParams): Promise<types.QueryConsumptionStatistics> {
        return get('/report/rptamr/event/getConsumptionStatistics', data);
    }
    getMapSession (data:types.GetGoogleMapSessionParams):Promise<types.GooleMapSessionData> {
        return post('/google/map/getGoogleMapSession', data);
    }
    getCstTypeList (): Promise<types.CstType[]> {
        return get('/business/common/mdr-home-page/getCstType');
    }
    getMeterTypeList (cstType?:string): Promise<types.MeterType[]> {
        return get('/business/common/mdr-home-page/getMeterType', {cstType});
    }
    getSchemeList (meterType:string): Promise<types.SchemeData[]> {
        return get('/business/common/mdr-home-page/getScheduleCurve', {meterType});
    }
    getEventDeviceStatistics (data:types.QueryEventDeviceStatisticsParams): Promise<types.EventDeviceStatisticsData[]> {
        return get('/business/common/mdr-home-page/getEventDeviceStatistics', data);
    }
    getMeterSnapshot (data: types.MeterSnapshot): Promise<types.MeterSnapshotData> {
        return post('/business/common/mdr-home-page/getMeterSnapshot', data);
    }
    controlSwitchStatus (data:types.SwitchStatus): Promise<string> {
        return post('/business/common/mdr-home-page/meterRelayControl', data);
    }
    getMeterTypeStatisicRatio ():Promise<types.MeterTypeStatisicRatioRows[]> {
        return get('/business/common/mdr-home-page/getMeterStatisticalByMeasureType');
    }
    getMeterConnectStatisticalByMeasureType (data: types.QueryMeterConnectStatisicParams): Promise<types.MeterConnectStatisicRows[]> {
        return get('/business/common/mdr-home-page/getMeterConnectStatisticalByMeasureType', data);
    }
    getMeterPushDataStatistics (data: types.QueryMeterPUSHStatisticParmas): Promise<types.Query34MeterPushStatisticsRows[]> {
        return get('/business/common/mdr-home-page/getMeterPushDataStatistics', data);
    }
    getSINAMEDPushStatistics (data: types.Query48MeterPUSHStatisticParmas): Promise<types.Query48MeterPUSHStatisticRows[]> {
        return get('/report/rptamr/sinamed-push-log/getPushStatistics', data);
    }
    getSINAMEDPushStatisticsByMeter (data: types.Query48MeterPUSHStatisticParmas): Promise<types.Query48MeterPUSHStatisticRows[]> {
        return get('/report/rptamr/sinamed-push-log/getPushStatisticsByMeter', data);
    }
}

export default new HomePage();


